module.exports = __webpack_public_path__ + "staticcomp/img/list_bottom_logo.19b068c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/list_bottom_logo.png
// module id = J3Al
// module chunks = 39